var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 29,
    viewBox: "0 0 36 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.249023,
    y: 0.0351562,
    width: 35.0539,
    height: 28.5714,
    fill: "url(#pattern0_10636_4667)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_10636_4667",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10636_4667",
    transform: "matrix(0.00905634 0 0 0.0111111 0.0924649 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_10636_4667",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAAAXNSR0IArs4c6QAABMlJREFUeF7t3L1vHEUUAPD39jbkDmJokgKRAgk6AknFkT/hFFvaXeQCQ2FRJA1xkCigw2kQdCROk5MocbPczskG3Fo0fEhIGJISqhApBVycBOfMnf3QoLvIxe7OzN7c+G79rp23783+9t14x6ddBP44EUAnVbgIMLSjJmBohnYk4KgMdzRDOxJwVIY7mqEdCTgqwx3N0I4EHJXhjmZoRwKOynBHM7QjAUdllB29uLhYfXj//iVCXADEV4DoGUdzm+wyiP8AwC0iWu12uzc3NjZ28yacCx1F0Wkg+gYAXpvssz702W0B4mySJHeyZpIJLTv5wfb2j4ysfRG3Hne79azOzoR+MwiuEOLn2mU4EABxKUmSlTSKTOgoDGU3v85+RgI/JEKcN4V+CAAnjMpw8KNEiBlTaGI3c4FEiNRVIm/pYGhzZ2DoAmhFDmHofLUuAdyUm4+ZnZ3bMnSnVjsDnrdAAJcA4LguOkNnS91Bz7vQarV+TQsJw/AsAnwNAKd1sBk6XamLnlfPQh4eMsCWt7vKzmboFGgCuCaEeF+nU6MguA6Il1WxDJ0itE9Ub7fbP6nw5HgURW8A0feqWIZOEar4/kwcx49UeHJ8fn7+xF6/LzdxuR+GHhH67Ubj2cfV6jZDqwR46SggZOkQBLjeEuKKTrooilaA6D1VLC8d6UK7BFAXQmzlAQZBcM5DlLd3TzG0SiBnw0IAs1nYA2S5YXlBpwR3dL7SLhA1wfNWK5XKLRna7/dfRfk7KdFFnU4epmdonXa0EMPQFhB1UjC0jpKFmMOCvgtENwjxW9/3f5fn0ev1XvYAGoP/Gzxv4dwmKoV7aMQver3e0vr6+k6axNzc3NO+768gwLsTJTXiZNxCI15NkmRZZ85RFC0D0cc6sdMQ4w6aaDlpt6+aoIRh+CECfGpyzKTGuoEugDwEKwv2+KFHQC4T9nihDdZk1Vfe0pp9FwFW9gE2XN/tjA/aIvLwIoyEfch3O+OBHgPySNgG8xnpYuZ8LccCnZVUtTzojhv9gSzwN8Iov+akpxJanptm593+u9M5t7m52df0eBKmmV877dRCyzPU7LyvTp46tdBsNnvaKoNAzfxaaacaepqwpx5adxlBgNjz/bfiON7TasEDQTaWkVJA62ITwEdCiM9MoXXz5+UtDbTmMvJHIsRLRaA182emLhW0Ruf9lQhxsii0Rv6jA63A+DIR4p1RoItil66jD+wgPwCiTw78Uv1zf2/vwtra2r1RoYtglxZaYgRB8GIF4Pw+4r1Op/NdkY1L3kUxuRspNbSNzlXl0N3UMLRKUmM8CkPlk2oMrQGpCmFolZClcYa2BKlKw9AqIUvjDG0JUpXm0KBVEzuK42O56ziKkKpzZmiVkKXxItD8YhRDfAJ4IIR4Lu0wftWPIaYi3PxVP2EYLiHANbvzKHc2JLrcardvGHV0o9E4XqtW5SNfZ8vNY+fsEOAXz/frcRz/awQtgwcvGJSPfjF2zvUYIM/GcfxnVpjylZn/d3atdhGIFgDgDL857AmlfFj/NyRa9Y4da2Z18jBaCW3ni8VZGNpRDzA0QzsScFSGO5qhHQk4KsMdzdCOBByV4Y5maEcCjspwRzO0IwFHZbijGdqRgKMy3NGOoP8DUqeMeYxkz1gAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.ab21fa58769e50781e229d4b5cc2e427.svg";
export { ForwardRef as ReactComponent };